<div class="wrapper">
  <div [ngClass]="{'!cursor-default':data?.accordion?.isDisabled}"
    class="header flex justify-between items-start cu"
    >
    <div class="left flex flex-row gap-[10px]">
      <div class="flex flex-col items-center justify-center relative top-[-15px]">
        <div [ngClass]="{'!invisible' : isFirst,'not-active' : data?.accordion?.isDisabled}" class="line top"></div>
        <div [ngClass]="{'active' : data?.accordion?.isActive, 'not-active' : data?.accordion?.isDisabled, }"
        class="square"></div>
        <div
          [ngClass]="{'active' : data?.accordion?.isActive, '!invisible' : isLast && !data?.accordion?.isActive, 'not-active' : data?.accordion?.isDisabled}"
        class="line middle"></div>
      </div>
      <div class="details-section flex flex-col items-start mb-[20px]">
        <div class="heading text-type-6 mb-[4px]" [ngClass]="data?.accordion?.isActive ? 'heading-active' : 'heading-normal'">{{ heading }}</div>
        @if (data?.accordion?.isDisabled) {
          <div class="subheading text-type-10">&nbsp;</div>
        } @else {
          <div class="subheading text-type-10">
            @switch (heading) {
              @case ('Request') {
                <span>
                  Sent on, {{ data?.externalTestDetails?.sentToLabDate | dateFormat :'very-long' }}
                </span>
              }
              @case ('Schedule') {
                <span>
                  {{
                  data?.externalTestDetails?.status !== 'sent_to_lab'
                  ? 'Scheduled for, ' + (data?.externalTestDetails?.request_date | dateFormat:'very-long')
                  : 'Test request received'
                  }}
                </span>
              }
              @case ('Record') {
                <span>
                  {{ data?.externalTestDetails?.inspection_detail?.id ? 'Visit details saved' : 'Fill in details' }}
                </span>
              }
              @case ('Report') {
                <span>
                  {{ data?.externalTestDetails?.material_test_report?.id ? 'Lab report uploaded' : 'Waiting for lab report' }}
                </span>
              }
              @case ('Result') {
                <span>
                  {{ (data?.externalTestDetails?.status === 'failed' || data?.externalTestDetails?.status === 'passed') ? (data?.externalTestDetails?.status === 'failed' ? 'Failed' : 'Passed') : 'Waiting for result' }}
                </span>
              }
            }
          </div>
        }
      </div>
    </div>
    @if (!data?.accordion?.isDisabled) {
      <div class="right">
        <mat-icon
          svgIcon="chevron-light"
          class="chevron"
          [class.expanded]="isExpanded"
          />
      </div>
    }
  </div>
  @if (isExpanded) {
    <div class="content">
      <ng-content />
    </div>
  }
</div>
